const envBaseURL = "https://sailshub.securespectrum.dk/api";
export default envBaseURL
